export default class ClampToggle {
    constructor() {
        this.button = document.getElementById("clamp-expand");
        this.desc = document.getElementById("clamp-description");
        this.label = document.getElementById("clamp-label");
        this.icon = document.getElementById("clamp-icon");

        this.init();
    }

    init() {
        if (!this.button || !this.desc || !this.label || !this.icon) return;

        this.button.addEventListener("click", () => {
            const isExpanded = this.desc.classList.toggle("expanded");

            this.label.textContent = isExpanded ? "Visa mindre" : "Läs mer";
            this.icon.classList.toggle("bi-chevron-down", !isExpanded);
            this.icon.classList.toggle("bi-chevron-up", isExpanded);
            this.button.setAttribute("aria-expanded", isExpanded.toString());

        });
    }
}
